// export { default } from './skip-to-main';

import SkipToMain from './skip-to-main';
import MainContent from './main-content';

export default SkipToMain;

export { MainContent };
